import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainPoints() {
  const points = ['Semana terminada sin saber exactamente cuánto ganaste ni cuánto gastaste', 'Precios fijados porque "las demás cobran eso", sin saber si te alcanza para vivir', 'Clientas que cancelan sin aviso y turnos vacíos que no sabés cómo llenar', 'WhatsApp lleno de consultas que preguntan precio, dicen "gracias" y nunca reservan', 'Sin saber qué publicar, sin sistema de fidelización, sin reseñas activas', 'Fin de semana agotada. Lunes: el mismo ciclo de vuelta.'];
  return <section className="py-20 px-4 bg-dark-card/30 border-y border-dark-border pt-[15px] pb-[15px]" data-id="element-203">
      <div className="max-w-3xl mx-auto" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-205">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-206">
            ¿Cuántos meses más vas a trabajar así?
          </h2>
          <p className="text-base text-gray-400" data-id="element-207">
            Sos manicurista. Amás lo que hacés. Pero nadie te dijo que ibas a
            pasar los domingos sin saber cuánto ganaste, cobrando lo que cobran
            las demás por miedo, y llegando al lunes con la agenda a medias y la
            caja mezclada con tu plata personal.
          </p>
          <p className="text-xl font-bold text-brand mt-6" data-id="element-208">
            No es falta de talento. Es falta de un sistema.
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-209">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start space-x-4 bg-dark-card border border-dark-border p-4 rounded-xl" data-id="element-210">
              <div className="mt-1 bg-red-500/20 p-1 rounded-full" data-id="element-211">
                <X className="w-5 h-5 text-red-500" data-id="element-212" />
              </div>
              <p className="text-gray-300 text-lg" data-id="element-213">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-214">
          <h3 className="text-2xl md:text-4xl font-black text-white" data-id="element-215">
            ¿Y si este fuera el último mes que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}